export default __webpack_public_path__ + "assets/images/76afa0fc5a3954219e65dc11278dfb66.png";